module.exports = __webpack_public_path__ + "img/git.036bf7c4.png";